import axios from "axios";

//const BASE_URL = "https://localhost:7123";
const BASE_URL = ""
const getAxiosInstance = () => {
  const userData = JSON.parse(localStorage.getItem("userData"));
  const AUTH_TOKEN = userData?.jwtToken;
  const customer = JSON.parse(localStorage.getItem("customer"))

  const instance = axios.create({
    baseURL: BASE_URL,
  });
  if (userData) {
    instance.defaults.headers.common["Authorization"] = `Bearer ${AUTH_TOKEN}`;
    instance.defaults.headers.common["x-customer-code"] = customer;
  }

  return instance;
};

export function post(apiPath, data, config=null) {
  if (Boolean(config))
    return getAxiosInstance().post(apiPath, data, config);
  return getAxiosInstance().post(apiPath, data);
}
export function post_file(apiPath, data) {
  return getAxiosInstance().post(apiPath, data, {responseType:"blob"});
}

export function get(apiPath,data) {
  if(Boolean(data)){
    return getAxiosInstance().get(apiPath,data);
  }else{
    return getAxiosInstance().get(apiPath);
  }
}
export function del(apiPath) {
  return getAxiosInstance().delete(apiPath);
}
export function put(apiPath, data) {
  if(Boolean(data)){
    return getAxiosInstance().put(apiPath, data);
  }else{
    return getAxiosInstance().put(apiPath);
  }
   
}

export function getDataPaginated(apiPath, pageIndex, rowsPerPage) {
  //Return data with currentPage, numOfPages
  const modifiedPath = `apiPath/?pageIndex=${pageIndex}&rowsPerPage=${rowsPerPage}`;
  return getAxiosInstance().get(modifiedPath);
}
